import { Component } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

class InterventionSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedTabId: 0,
			workOrder: this.props.defaultWorkOrder,
		};
	}

	handleTabChange = (event, value) => {
		this.setState({ selectedTabId: value });
		event.stopPropagation();
	};

	//changement d'ordre de travail
	updateWorkOrder(newValue) {
		let wo = {
			num: "autre",
		};

		if (newValue.target.value !== "autre") {
			wo = this.props.workOrders.find((wo) => {
				return wo.num === newValue.target.value;
			});
		}

		this.setState({
			workOrder: wo,
		});

		this.props.updateWorkOrder(wo);
	}

	render() {
		let workOrders = this.props.workOrders;
		let selectRows = [];
		let workOrderElements = []; //Key: onglet, value: liste d'OT
		let tabs = [];
		let { selectedTabId } = this.state;

		selectRows.push(
			<MenuItem key={0} value="autre">
				<Typography className="row" style={{ width: "inherit", color: "orange" }}>
					{"Saisie manuelle OT"}
				</Typography>
			</MenuItem>
		);

		workOrders.forEach((wo, i) => {
			if (!workOrderElements[wo.status]) workOrderElements[wo.status] = [];

			let bgColor = "White";

			if (workOrderElements[wo.status].length % 2 === 0) bgColor = "#b3e5fc";

			workOrderElements[wo.status].push(
				<MenuItem
					key={i + 1}
					value={wo.num}
					style={{
						height: "auto",
						paddingTop: 0,
						paddingBottom: 0,
						alignItems: "baseline",
						backgroundColor: bgColor,
					}}
				>
					<Typography className="row" style={{ width: "inherit", marginRight: 5 }}>
						{wo.num}
					</Typography>
					<div>
						<Typography
							className="row"
							style={{
								fontSize: 11,
								color: "#5887ee",
								fontWeight: "bold",
								overflowX: "auto",
								paddingTop: 0,
								paddingBottom: 0,
								whiteSpace: "pre-line",
							}}
						>
							{wo.customer}
						</Typography>
						<Typography
							className="row"
							style={{
								fontSize: 10,
								color: "grey",
								overflowX: "auto",
								paddingTop: 0,
								paddingBottom: 0,
								whiteSpace: "pre-line",
							}}
						>
							{wo.description ? wo.description : ""}
						</Typography>
					</div>
				</MenuItem>
			);
		});

		Object.keys(workOrderElements).map((key, index) => tabs.push(<Tab key={index} label={key} />));

		selectRows.push(
			<div key="divTabs">
				<Tabs
					key="tabWorkOrders"
					value={selectedTabId}
					onChange={this.handleTabChange}
					indicatorColor="primary"
					textColor="primary"
				>
					{tabs}
				</Tabs>
			</div>
		);

		selectRows.push(
			Object.keys(workOrderElements).map((key, index) => {
				return selectedTabId === index && workOrderElements[key];
			})
		);

		return (
			<div className="row col-lg-6 col-md-6 col-sm-6 col-12">
				<FormControl className="row">
					<InputLabel id="ot-label">Ordre de travail</InputLabel>
					<CustomizedSelect
						labelId="ot-label"
						id="ot"
						value={this.state.workOrder.num}
						onChange={this.updateWorkOrder.bind(this)}
						placeholder="Ordre de travail"
						label="Ordre de travail"
						className="full_size">
						{selectRows}
					</CustomizedSelect>
				</FormControl>
			</div>
		);
	}
}

export default InterventionSelect;
